import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Modal,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// actions
import {
  resetDepartments,
  getDepartments,
  deleteDepartment,
} from "../../store/departments/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";
import { renderPagination } from "../../Libs/CrudUtils/crudUtils";

const Departments = ({ t }) => {
  const dispatch = useDispatch();
  const qtdDefault = 7;

  const {
    dataDepartment,
    loadingDepartment,
    loadingDeleteDepartment,
    errorDepartment,
    successDeleteDepartment,
    idDepartmentDelete,
  } = useSelector((state) => state.Department);

  const [page, setPage] = useState(1);
  const [departmentId, setDepartmentId] = useState("");
  const [departmentName, setDepartmentName] = useState("");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [slug, setSlug] = useState("");

  const [nameF, setNameF] = useState("");
  const [emailF, setEmailF] = useState("");
  const [slugF, setSlugF] = useState("");

  const [modal, setModal] = useState(false);

  const [notFound, setNotFound] = useState(false);

  const handleFilter = () => {
    setPage(1);
    dispatch(getDepartments(1, qtdDefault, name, email, slug));
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getDepartments(value, qtdDefault));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataDepartment && dataDepartment.paging) {
      if (page < dataDepartment.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const toggleModal = useCallback(() => {
    setModal(!modal);
  }, [modal]);

  const handleDelete = () => {
    if (departmentId) {
      dispatch(deleteDepartment(departmentId));
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };

  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };

  useEffect(() => {
    if (errorDepartment) {
      showToast(
        "error",
        errorDepartment === "Invalid data"
          ? t("Invalid data")
          : errorDepartment[0].value === "email must be a valid email"
          ? t("email must be a valid email")
          : errorDepartment[0].value === "not found"
          ? t("Department Not found")
          : errorDepartment === "Your session has expired"
          ? t("Your session has expired")
          : errorDepartment ===
            "Sorry! the page you are looking for could not be found"
          ? t("Sorry! the page you are looking for could not be found")
          : errorDepartment ===
              "Sorry! something went wrong, please contact our support team" &&
            t("Sorry! something went wrong, please contact our support team")
      );
      dispatch(resetDepartments());
    } else if (errorDepartment && idDepartmentDelete) {
      showToast("error", t("Delete error"));
      toggleModal();
      dispatch(resetDepartments());
      dispatch(getDepartments());
    }
  }, [
    dispatch,
    idDepartmentDelete,
    toggleModal,
    errorDepartment,
    dataDepartment,
    t,
  ]);

  useEffect(() => {
    if (successDeleteDepartment) {
      showToast("success", t("Department deleted"));
      toggleModal();
      dispatch(resetDepartments());
      dispatch(getDepartments());
    }
  }, [dispatch, toggleModal, successDeleteDepartment, t]);

  useEffect(() => {
    if (dataDepartment !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataDepartment]);

  useEffect(() => {
    handleFilter();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/departments"
            title={t("Dashboard")}
            breadcrumbItem={t("Departments")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <AvForm onValidSubmit={handleFilter}>
                    <Row>
                      <Col xs="12" md="4" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            onChange={(e) => setNameF(e.target.value)}
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            value={name}
                            validate={{
                              maxLength: {
                                value: 45,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="4" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            onChange={(e) => setEmailF(e.target.value)}
                            label={t("Email")}
                            id="email"
                            name="email"
                            type="text"
                            className="form-control"
                            placeholder={t("Email") + "..."}
                            value={email}
                            validate={{
                              email: {
                                format: "m@m.gmail.com",
                                errorMessage: t("Invalid field"),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Invalid field"),
                              },
                              maxLength: {
                                value: 45,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col xs="12" md="4" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            onChange={(e) => setSlugF(e.target.value)}
                            label={t("Slug")}
                            id="slug"
                            name="slug"
                            type="text"
                            className="form-control"
                            placeholder={t("Slug") + "..."}
                            value={slug}
                            validate={{
                              maxLength: {
                                value: 60,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="12"
                        lg="3"
                        xl="auto"
                        className="mb-3"
                        style={{ marginTop: "1.7rem" }}
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                          onClick={() => {
                            setName(nameF);
                            setEmail(emailF);
                            setSlug(slugF);
                          }}
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        md="12"
                        lg="12"
                        xl="auto"
                        className="mb-3 ml-auto"
                        style={{ marginTop: "1.7rem" }}
                      >
                        <div className="text-sm-right mb-3" id="new-department">
                          <Link to="/department">
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Department")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>
                              <span className="ml-2">{"#"}</span>
                            </th>
                            <th>{t("Name")}</th>
                            <th>{t("Email")}</th>
                            <th>{t("Slug")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingDepartment ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataDepartment &&
                            dataDepartment.departments &&
                            dataDepartment.departments.length > 0 ? (
                            dataDepartment.departments.map(
                              (department, key) => (
                                <tr key={key}>
                                  <td className="pl-4">{key + 1}</td>
                                  <td className="column-text-overflow-10">
                                    {department.name}
                                  </td>
                                  <td className="column-text-overflow-15">
                                    {department.email}
                                  </td>
                                  <td className="column-text-overflow-15">
                                    {department.slug}
                                  </td>
                                  <td className="pl-0">
                                    <Link
                                      to={`/department/${departmentId}`}
                                      className="text-primary text-center"
                                      id="edit"
                                    >
                                      <i
                                        className="mdi mdi-pencil font-size-18 px-2"
                                        id="edittooltip"
                                        onMouseUp={() => {
                                          setDepartmentId(department.id);
                                          setDepartmentName(department.name);
                                        }}
                                      >
                                        <UncontrolledTooltip
                                          placement="auto"
                                          target="edittooltip"
                                        >
                                          {t("Edit")}
                                        </UncontrolledTooltip>
                                      </i>
                                    </Link>
                                    <span style={{ cursor: "pointer" }}>
                                      <i
                                        className="mdi mdi-window-close text-danger font-size-18 px-2"
                                        id="deletetooltip"
                                        onMouseUp={() => {
                                          setDepartmentId(department.id);
                                          setDepartmentName(department.name);
                                        }}
                                        onClick={toggleModal}
                                      >
                                        <UncontrolledTooltip
                                          placement="auto"
                                          target="deletetooltip"
                                        >
                                          {t("Delete")}
                                        </UncontrolledTooltip>
                                      </i>
                                    </span>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal}>
                        <div className="modal-body">
                          <h5>
                            {t("Do you want delete") +
                              " " +
                              departmentName +
                              " ?"}
                          </h5>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>

                          {loadingDeleteDepartment ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>
                  {renderPagination(
                    page,
                    dataDepartment?.paging,
                    handlePreviousPage,
                    handlePage,
                    handleNextPage
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Departments);
